var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon19BlogFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 8c1.1 2 3.54 4.29 3.54 4.29v.01s0 0 0 0c.24.24 4.06 4.05 9.22 4.05a13.82 13.82 0 0 0 5.92-1.32 14.3 14.3 0 0 0 1.7-1.07l.45-.38A8 8 0 0 0 23 12.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 16.59c1.1-2 3.54-4.29 3.54-4.29m0 0s0 0 0 0c.24-.26 4.06-4.06 9.22-4.06 3.55 0 6.59 1.25 8.5 3.19.26.28.52.56.74.87"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+DQogICAgPHBhdGggZD0iTTEgOGMxLjEgMiAzLjU0IDQuMjkgMy41NCA0LjI5di4wMXMwIDAgMCAwYy4yNC4yNCA0LjA2IDQuMDUgOS4yMiA0LjA1YTEzLjgyIDEzLjgyIDAgMCAwIDUuOTItMS4zMiAxNC4zIDE0LjMgMCAwIDAgMS43LTEuMDdsLjQ1LS4zOEE4IDggMCAwIDAgMjMgMTIuMyIvPg0KICAgIDxwYXRoIGQ9Ik0xIDE2LjU5YzEuMS0yIDMuNTQtNC4yOSAzLjU0LTQuMjltMCAwczAgMCAwIDBjLjI0LS4yNiA0LjA2LTQuMDYgOS4yMi00LjA2IDMuNTUgMCA2LjU5IDEuMjUgOC41IDMuMTkuMjYuMjguNTIuNTYuNzQuODciLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgIcon19BlogFish as ReactComponent };